import { Progress } from "antd";

export default function DeviceManagement() {
	const deviceData = [
		{ label: "Field Device", count: 0, percent: 0 },
		{ label: "Controller", count: 22, percent: 73 },
		{ label: "SCADA,HMI", count: 7, percent: 23 },
		{ label: "EWS,Historian", count: 0, percent: 0 },
		{ label: "Computer", count: 1, percent: 3 },
	];

	return (
		<div className="col-lg-4 mb-3">
			<div className="card bg-secondary h-100">
				<div className="card-body">
					<h5 className="text-white mb-6">
						Device Management
						<span className="text-white-50 fs-8 mb-3 ms-2">Status (1h)</span>
					</h5>

					<div>
						<div
							style={{
								minHeight: "200px",
								overflowY: "auto",
								overflowX: "hidden",
							}}
						>
							{deviceData.map((device, index) => (
								<div key={index} className="mb-4">
									<div className="d-flex justify-content-between align-items-center mb-2">
										<span className="text-white fs-7">{device.label}</span>
										<span className="text-white fs-6 fw-bold">{device.count}</span>
									</div>
									<Progress
										percent={device.percent}
										strokeColor="#50cd89"
										showInfo={false}
										strokeWidth={12}
										trailColor="#2b2b40"
									/>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
